<template>
    <div>
        <f7-sheet
            :opened="shown"
            class="status-dialogs-sheet status-dialogs-sheet__list"
            :close-by-backdrop-click="false"
            :close-by-outside-click="false"
            :swipe-to-close="true"
            @sheet:closed="statusDialogOrderCardClosed"
            >
            <div class="status-dialogs-sheet__line"></div>
            <div
                v-if="ordersStatuses && ordersStatuses.length"
                class="status-dialogs-orders">
                <div v-if="showAllOrders">
                    <template v-for="(order, index) in ordersStatusesShown">
                        <div 
                            v-if="order && order.id"  
                            :key="`status-dialog-order-card-${index}`"
                            @click="openOrder(order)"
                            class="status-dialogs-sheet__item">
                            <StatusDialogOrderCard 
                                :order="order" />
                        </div>
                    </template>

                    <!-- <div 
                        class="status-dialogs-sheet__orders-hide"
                        @click="showAllOrders = false">
                        -
                    </div> -->
                </div>

                <div v-else
                    @click="openOrder(ordersStatuses[0])">
                    <div 
                        v-if="ordersStatuses.length > 1" 
                        @click="showAllOrders = true"
                        class="status-dialogs-sheet__orders-count__container">
                        <div class="status-dialogs-sheet__orders-count">
                            +{{ ordersStatuses.length - 1 }}
                        </div>
                    </div>
                    <StatusDialogOrderCard 
                        :order="ordersStatuses[0]"
                        :show-more="showAllOrders === false && ordersStatuses.length > 1" />
                </div>
            </div>
        </f7-sheet>
    </div>
</template>


<script>
    import moment from '../../plugins/moment';
    import { mapState } from 'vuex';
    import store from '@/store';
    import { ORDER_STATUS } from '@/js/utils/vars';
    import Sheet from '@/components/Sheet';
    import StatusDialogOrderCard from './StatusDialogOrderCard';
    import StatusDialogOrderDetails from './StatusDialogOrderDetails';
    import StatusDialogOrderReview from './StatusDialogOrderReview';
    import { sendAppMetricaEvent, checkEnabledService } from '@/js/utils/service-helpers';

    export default {
        name: 'StatusDialog',

        components: {
            Sheet,
            StatusDialogOrderCard,
            StatusDialogOrderDetails,
            StatusDialogOrderReview
        },

        props: {
            canOpen: {
                type: Boolean,
                default: true,
            },
            statuses: {
                type: Array,
                default: () => ([]),
            },
        },
        
        data: () => ({
            ORDER_STATUS,
            shown: false,
            detailsShown: false,
            reviewShown: false,
            orderDetails: {},
            orderReview: {},
            showAllOrders: false,
        }),

        computed: {
            ...mapState('orders', ['ordersStatuses']),
            ordersStatusesShown() {
                return this.ordersStatuses.slice(0, 5);
            }
        },

        watch: {
            canOpen(val) {
                if (val) this.checkOrderStatuses();
            },
        },

        async mounted() {
            if(this.checkRouteName()) {
                await store.dispatch('orders/getOrdersStatuses', { page: 1 });
                await this.checkOrderStatuses();
            }
            try {
                if(this.$root.getOrdersStatusesTimerId) {
                    clearInterval(this.$root.getOrdersStatusesTimerId);
                }
                this.$root.getOrdersStatusesTimerId = setInterval(async () => {
                    if(this.checkRouteName()) {
                        await store.dispatch('orders/getOrdersStatuses', { page: 1 });
                        this.checkOrderStatuses();
                    }
                }, 10000)
            } catch (e) {}
            try {
                if(this.$root.checkRouteNameTimerId) {
                    clearInterval(this.$root.checkRouteNameTimerId);
                }
                this.$root.checkRouteNameTimerId = setInterval(async () => {
                    if(!this.checkRouteName()) {
                        this.sheetClose();
                        this.$emit('processing', false);
                        this.$root.$emit('statusDialogHide');
                        clearInterval(this.$root.checkRouteNameTimerId);
                    }
                }, 200)
            } catch (e) {}
        },

        methods: {
            checkRouteName() {
                const routeName = this?.$f7?.views?.main?.router?.url;
                if(routeName && (routeName === '/' || routeName === '/home')) {
                    return true;
                }
                return false;
            },
            statusDialogOrderCardClosed() {
                sendAppMetricaEvent('order_status_screen_closed');
                this.$emit('processing', false);
            },
            sheetClose() {
                this.shown = false;
                this.detailsShown = false;
                this.$f7.sheet.close();
            },
            withoutDelivery(order) {
                return (order.delivery_type === DELIVERY_TYPE.WITHOUT || order.delivery_type === DELIVERY_TYPE.COLLECT);
            },
            openOrder(order) {
                this.sheetClose();
                const orderId = order.id;
                let review = false;
                if ([ORDER_STATUS.PAYMENT_CORRECTION, ORDER_STATUS.DONE, ORDER_STATUS.DELIVERED_DOOR].indexOf(order.status) >= 0) {
                    review = true;
                } 
                if (order.status === ORDER_STATUS.AWAITING_READY && this.withoutDelivery(order)) {
                    review = true;
                }
                this.$f7.views[0].router.navigate({
                    name: 'orders-detail',
                    params: {
                        orderId
                    },
                    query: {
                        review
                    }
                });
            },
            async checkOrderStatuses() {
                if (this.ordersStatuses && this.ordersStatuses.length > 0) {
                    for (const order of this.ordersStatuses) {
                        if (order?.status === 5 && !!order?.delivered_door === true) {
                            order.status = 25;
                        }
                    }
                    this.ordersStatuses.sort(order => order.id);
                    if(!this.detailsShown && !this.shown) {
                        this.$f7.sheet.close();
                        sendAppMetricaEvent('order_status_screen_viewed', {
                            status: this.getStatus(this.ordersStatuses[0]),
                            source: 'main_screen'
                        });
                        this.$root.$emit('statusDialogShown');
                        this.shown = true;
                        this.$emit('processing', true);
                    }
                } else {
                    this.shown = false;
                    this.$root.$emit('statusDialogHide');
                    this.$emit('waiting');
                }
            },
            openSupport() {
                this.sheetClose();
                this.$f7.views[0].router.navigate({
                    name: 'feedback'
                });
                sendAppMetricaEvent('support_order_status_clicked');
            },

            paidWaitingFree(order) {
                if (order.status === ORDER_STATUS.MEETING_POINT) {
                    if (order.status === ORDER_STATUS.MEETING_POINT) {
                        const currentTime = moment().unix();
                        const updatedTime = moment(order.meeting_point_at).unix();
                        return currentTime - updatedTime < order.waiting_free_seconds;
                    }
                }
            },
            getStatus(order) {
                switch (order.status) {
                case ORDER_STATUS.SUBMITTED:
                case ORDER_STATUS.IN_WORK:
                case ORDER_STATUS.ACCEPTED:
                    return 'submitted';
                case ORDER_STATUS.PREPARED:
                case ORDER_STATUS.PAID:
                case ORDER_STATUS.AWAITING:
                    return 'awating';
                case ORDER_STATUS.AWAITING_READY:
                case ORDER_STATUS.DELIVERY:
                case ORDER_STATUS.DELIVERY_CONCIERGE:
                    return 'delivery';
                case ORDER_STATUS.MEETING_POINT:
                    if(this.paidWaitingFree(order)) {
                        return 'free_waiting';
                    }
                    return 'paid_waiting';
                case ORDER_STATUS.DONE:
                case ORDER_STATUS.PAYMENT_CORRECTION:
                case ORDER_STATUS.DELIVERED_DOOR:
                    return 'done';
                case ORDER_STATUS.CANCELED:
                case ORDER_STATUS.DECLINED:
                    return 'canceled';
                default:
                    return '';
                }
            },
        }
    };
</script>

<style lang="scss">
.status-dialogs-sheet {
    height: auto;
    z-index: 12500;
    padding-bottom: 70px;
    overflow: visible;

    &__list {
        .status-dialogs-orders {
            padding-top: 4px;
            max-height: 500px;
            overflow-y: hidden;
        }
    }
    &__details {
        z-index: 12600;

        .sheet-modal-inner {
            overflow: visible;
        }
    }

    &__buttons {
        width: 100%;
        top: -60px;
        left: 0;
        position: fixed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        
        &__back {
            width: 40px;
            height: 40px;
            border-radius: 30px;
            background: #FFFFFF url('../../static/statuses-new/back.svg') no-repeat center center;
        }
        &__support {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 40px;
            padding: 0 16px;
            border-radius: 30px;
            font-weight: 400;
            font-size: 16px;
            line-height: 120%;
            text-align: center;
            color: #232321;
            background: #FFFFFF;
        }
    }

    &__line {
        position: absolute;
        top: 8px;
        left: 50%;
        width: 40px;
        height: 4px;
        margin-left: -20px;
        border-radius: 12px;
        background-color: #CDD3D9;
    }

    &__item {
        padding: 12px 0;
        border-top: 1px solid #9FA8B1;
        &:first-child {
            padding-top: 0;
            border-top: none;
        }
    }

    &__orders-count {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 90px;
        background: #CC9C6E;
        font-weight: 600;
        font-size: 6px;
        line-height: 100%;
        color: #232321;

        &__container {
            position: absolute;
            top: 15px;
            right: 12px;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    // &__orders-hide {
    //     position: absolute;
    //     top: 19px;
    //     right: 20px;
    //     width: 16px;
    //     height: 16px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     border-radius: 90px;
    //     background: #CC9C6E;
    //     font-weight: 600;
    //     font-size: 14px;
    //     line-height: 100%;
    //     color: #232321;
    // }
}
.status-dialogs-toolbar-single {
    position: fixed;
    width: 100vw;
    max-width: 600px;
    left: 0;
    padding: 0 30px;
    bottom: calc(constant(safe-area-inset-bottom) + 80px);
    bottom: calc(env(safe-area-inset-bottom) + 80px);
    z-index: 10000;
}
.status-dialogs-toolbar-all {
    position: fixed;
    width: 100vw;
    max-width: 600px;
    padding: 0;
    // margin: 0 -20px;
    bottom: calc(constant(safe-area-inset-top) + 80px);
    bottom: calc(env(safe-area-inset-top) + 80px);
    z-index: 10000;
}
.status-dialogs-orders {
    // z-index: 10000;
    // position: fixed;
    // bottom: 25%;
    .swiper-slide {
        padding-left: 20px;
        &:last-child {
            padding-right: 20px;
        } 
    }
}
.status-dialogs-swiper {
    .swiper-slide {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}
</style>
